import { useEffect } from "react";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { ToggleButton, DecimalInput } from "components";
import { useInput } from "hooks";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveAdditionalCouponTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const val = useInput("2.00");
  const type = useInput("Coupon Available Through Sunday Paper");
  const isPurchase = useInput(false);
  const purVal = useInput("");
  const purType = useInput("");
  const suffix = useInput("");

  const typeData = [
    {
      id: "Coupon Available Through Sunday Paper",
      title: "Coupon Available Through Sunday Paper",
    },
    { id: "Video Value Coupon", title: "Video Value Coupon" },
    { id: "eSavers Coupon", title: "eSavers Coupon" },
  ];
  const typeData2 = [
    { label: "$", value: "$", },
    { label: "Unit", value: "Unit" },
  ];

  const handleUpdateValue = (isUT, v, t, isP, pv, pt, suf) => {
    onChange(
      `${isUT ? "Up To" : ""}${v ? ` $${formatDollarValue(v)}` : ""}${t ? ` ${t}` : ""}${isP ? ` w/purchase/${pt === "$" ? `$${formatDollarValue(pv)}` : pv}` : ""
      }${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    let main = value;
    if (value.startsWith("Up To")) {
      isUpTo.setValue(true);
      main = main.slice(5).trim();
    } else {
      isUpTo.setValue(false);
    }
    const purIndex = main.indexOf("w/purchase/");
    if (purIndex > 0) {
      const tv = main.slice(0, purIndex);
      const typeIndex = tv.indexOf(" ");
      val.setValue(tv.slice(0, typeIndex).length > 0 ? tv.slice(1).trim() : "");
      type.setValue(tv.slice(typeIndex).trim());
      main = main.slice(11);
      const sufIndex = main.indexOf(" ");
      const ptv = main.slice(0, sufIndex);
      if (ptv.startsWith("$")) {
        purType.setValue("$");
        purVal.setValue(ptv.slice(1));
      } else {
        purType.setValue("Unit");
        purVal.setValue(ptv);
      }
      suffix.setValue(main.slice(sufIndex).trim());
    }

    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton
          className="mt-3 mr-2"
          style={{ width: '30%' }}
          label="Up To"
          value={isUpTo.value}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, val.value, type.value, isPurchase.value, purVal.value, purType.value, suffix.value);
          }}
        />
        <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '90%' }}
          value={val.value}
          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, e, type.value, isPurchase.value, purVal.value, purType.value, suffix.value);
          }}
        />

        <AutocompleteFreeText
          label="Type"
          style={{ width: '100%' }}
          data={typeData}
          value={type.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, e, isPurchase.value, purVal.value, purType.value, suffix.value);
          }}
        />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton
          className="mt-3"
          label="w/purchase"
          value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, type.value, e, purVal.value, purType.value, suffix.value);
          }}
        />

        {purType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '90%' }} className="ml-2"
            value={purVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              purVal.setValue(e);
              handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, e, purType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '90%' }} className="ml-2"
            allowclear="true" inputType="float" value={purVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              purVal.setValue(e);
              handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, e, purType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '90%' }} className="mx-2"
          options={typeData2} value={purType.value} disabled={!isPurchase.value}
          onChange={(e) => {
            purType.setValue(e);
            const nextPurVal = e === "$" ? formatDollarValue(purVal.value) : purVal.value;
            purVal.setValue(nextPurVal);
            handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, nextPurVal, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" style={{ width: '90%' }}
          allowclear="true" value={suffix.value} className="ml-2"
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, type.value, isPurchase.value, purVal.value, purType.value, e);
          }}
        />
      </div>
    </>
  );
};